module.exports = __webpack_public_path__ + "static/images/arrow.j_tQQ3J.svg";